export function animateCounter(
    start: number,
    end: number,
    duration: number,
    onUpdate: (val: string) => void
): () => void {
    let cancelled = false
    const startTime = performance.now()
    const range = end - start

    function step(currentTime: number) {
        if (cancelled) return
        const elapsed = currentTime - startTime
        const safeDuration = duration === 0 ? 1 : duration // Prevent division by zero
        const progress = Math.min(elapsed / safeDuration, 1)
        const eased = easeOutLog(progress)

        if (progress < 1) {
            const currentValue = Math.round(start + range * eased)
            onUpdate(formatValue(currentValue))
            requestAnimationFrame(step)
        } else {
            onUpdate(formatValue(end))
        }
    }

    requestAnimationFrame(step)

    return () => {
        cancelled = true
    }
}

function easeOutLog(t: number): number {
    const LOG_BASE = 100
    return Math.log10(1 + (LOG_BASE - 1) * t) / Math.log10(LOG_BASE)
}

function formatValue(n: number): string {
    if (n >= 1000) {
        return `${(n / 1000).toFixed(1)}k`
    }
    return n.toString()
}
